var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('el-row',{staticClass:"main_row"},[_c('el-col',{staticClass:"main_col",attrs:{"span":24}},[_c('product-table',{ref:"productTable"})],1)],1),_c('add-product-dialog',{on:{"getMsg":_vm.getProductMsg}}),_c('copy-product-dialog',{on:{"getMsg":_vm.getProductMsg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }